import { ResourceType } from '../enums/resource-type.enum';
import { ResourceBlockFunction } from '../interfaces/resource-block-function.interface';

export const goalsAndInterventionsBlock: ResourceBlockFunction = () => ({
  resourceType: ResourceType.carePlan,
  isResourceFromField: true,
  fieldForResources: 'activities',
  fieldGroups: [
    {
      name: ({ resource }) => resource?.content?.nature || 'my_doctor_goal_intervention',
      fields: [
        {
          label: 'my_doctor_type_of_help',
          fieldName: 'typeOfHelp',
          prepareData: (data) => data.coding?.[0]?.display,
        },
        {
          label: 'my_doctor_frequency',
          fieldName: 'frequency',
          prepareData: (data) => data,
        },
        {
          label: 'my_doctor_performer',
          fieldName: 'performer',
          prepareData: (data) => data?.display,
        },
      ],
    },
  ],
});
